module.exports = __webpack_public_path__ + "img/CellCycle-OVCA_GSE227019.b91b99b4.png";